import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQueryWithReauth } from './baseQuery';
import {
  DataDTOCompleteSsoRequest,
  DataDTOPendingAccessSsoResponse,
  DataDTOSsoOptions,
  DataDTOUserTokenData,
} from 'src/types/api/generated/api';
export type SsoCompleteResult =
  | { kind: 'token'; data: DataDTOUserTokenData }
  | { kind: 'pending'; data: DataDTOPendingAccessSsoResponse };

export const ssoAPI = createApi({
  reducerPath: 'ssoAPI',
  baseQuery: axiosBaseQueryWithReauth({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getSsoOptions: builder.query<DataDTOSsoOptions, { host: string }>({
      query: ({ host }) => ({
        url: 'Sso/options',
        method: 'GET',
        params: { host },
        useAuth: false,
      }),
    }),
    completeSso: builder.mutation<SsoCompleteResult, DataDTOCompleteSsoRequest>({
      query: (body) => ({
        url: 'Sso/complete',
        method: 'POST',
        body,
        useAuth: false,
      }),
      transformResponse: (data, meta: any): SsoCompleteResult =>
        meta?.status === 201
          ? { kind: 'pending', data: data as DataDTOPendingAccessSsoResponse }
          : { kind: 'token', data: data as DataDTOUserTokenData },
    }),
  }),
});

export const { useGetSsoOptionsQuery, useCompleteSsoMutation } = ssoAPI;
